<script>
    import { user } from "../../../stores";

    import { signOut, goToURL } from "../../../Utils/utilFunctions.svelte";

    import { isMobile } from "../../../stores";

    import SidebarMobile from "./SidebarMobile.svelte";

    import { userRoles } from "../../../Utils/utilEnums.svelte";

    export let sidebarExpanded;

    const LogOut = () => {
        signOut({ reason: "User logout" });
    };

    const RedirectToDashboard = () => {
        goToURL("/");
    };
    const changeRole = (tempRole) => {
        $user.role = tempRole;
    };

    const goToProfile = () => {
        goToURL("/profile");
        hideMenu();
    };

    const showMenu = () => {
        if (document.getElementById("dropdownMenu"))
            document.getElementById("dropdownMenu").style.display = "flex";
    };

    const hideMenu = () => {
        if (document.getElementById("dropdownMenu"))
            document.getElementById("dropdownMenu").style.display = "none";
    };
</script>

<div class="navbar p-2 shadow-md shadow-slate-200 justify-between">
    {#if $isMobile}
        <div class="flex items-center cursor-pointer w-12 h-10">
            <SidebarMobile bind:sidebarExpanded />
        </div>
    {:else}
        <div
            class="flex items-center cursor-pointer"
            on:click|preventDefault={RedirectToDashboard}
        >
            <img
                src="/imgs/Logo.png"
                alt=""
                class="bg-gray-200 w-12 h-12 rounded-full border-4 mr-4"
            />
            <p class="w-auto wrap text-lg">Anaemate Management Dashboard</p>
        </div>
    {/if}

    <!-- svelte-ignore a11y-mouse-events-have-key-events -->
    <div class="flex-none ml-2" on:mouseleave={hideMenu}>
        <ul class="menu menu-horizontal p-0">
            <!-- <ul id="dropdownMenu" class="z-index-4">
                {#each userRoles as role}
                    <div
                        class="flex items-center justify-start pl-4 gap-x-2 bg-zinc-200 border-0 text-[#6F726C] w-48 h-16 rounded rounded-bl-lg rounded-br-lg cursor-pointer hover:bg-zinc-300"
                        on:click={() => changeRole(role.id)}
                    >
                        <span>{role.type}</span>
                    </div>
                {/each}
            </ul> -->
            <li tabindex="0" class="justify-end">
                {#if $isMobile}
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a
                        class="flex"
                        on:click={() => {
                            document.getElementById(
                                "dropdownMenu",
                            ).style.display = "";
                        }}
                    >
                        <div class="flex flex-col items-end">
                            <div>
                                {$user.name}
                            </div>
                        </div>
                        <svg
                            class="fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            ><path
                                d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            /></svg
                        >
                    </a>
                {:else}
                    <a href="/#/" class="flex" on:mouseenter={showMenu}>
                        <div class="flex flex-col items-end">
                            <div>
                                {$user.name}
                            </div>
                        </div>
                        <svg
                            class="fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            ><path
                                d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            /></svg
                        >
                    </a>
                {/if}
                <ul id="dropdownMenu" class="z-[1000]">
                    <div
                        class="flex items-center justify-start pl-4 gap-x-2 bg-zinc-200 border-0 text-[#6F726C] w-48 h-16 rounded-tl-lg rounded-tr-lg cursor-pointer hover:bg-zinc-300"
                        on:click={goToProfile}
                    >
                        <i
                            class="fa-regular fa-address-card text-[16px] pb-1"
                        />
                        <span>Profile</span>
                    </div>
                    <div
                        class="flex items-center justify-start pl-4 gap-x-2 bg-zinc-200 border-0 text-[#6F726C] w-48 h-16 rounded-bl-lg rounded-br-lg cursor-pointer hover:bg-zinc-300"
                        on:click={LogOut}
                    >
                        <i
                            class="fa-sharp fa-solid fa-arrow-right-from-bracket text-[16px] pb-1"
                        />
                        <span>Log out</span>
                    </div>
                </ul>
            </li>
        </ul>
    </div>
</div>
